import { useMutation } from 'react-query'

import { createInvoiceDraft } from '../../../query-api'

export const useCreateInvoiceDraft = () => {
  const { mutate, isLoading: isProcessing } = useMutation(createInvoiceDraft)

  return { createInvoiceDraft: mutate, isProcessing }
}
